module.exports = __webpack_public_path__ + "img/play_watch.f28954f9.svg";